// Copyright (C) Konrad Gadzinowski

import bootstrap from "bootstrap/dist/js/bootstrap.js"

export const Modal = bootstrap.Modal
export const Dropdown = bootstrap.Dropdown
export const Tooltip = bootstrap.Tooltip
export const Toast = bootstrap.Toast
export const Carousel = bootstrap.Carousel

export type Modal = any
export type Dropdown = any
export type Tooltip = any
export type Toast = any
export type Carousel = any
